import { FC } from 'react'

import { Modal as MantineModal, ModalProps } from '@mantine/core'
import styled from 'styled-components'

import { useResponsive } from 'src/Helpers/useResponsive.tsx'

const StyledModal = styled(MantineModal)`
  .mantine-Modal-inner {
    left: 0;
  }
`

export const Modal: FC<ModalProps> = (props) => {
  const { isTablet } = useResponsive()

  return (
    <StyledModal
      size={isTablet ? '100%' : '60%'}
      transitionProps={{ transition: 'slide-up', duration: 400 }}
      {...props}
    >
      {props.children}
    </StyledModal>
  )
}
